<h2 mat-dialog-title>Meter Events</h2>

<mat-dialog-content>
  <app-meter-events [userUid]="userUid()"></app-meter-events>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton type="button" mat-dialog-close>Close</button>
</mat-dialog-actions>
